import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import '../styles/Hero.css';

const Hero = ({ lang }) => {
  const [displayText, setDisplayText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const fullText = lang.HERO_TITLE || 'ISP CLUB';
  const typingRef = useRef(null);

  useEffect(() => {
    let index = 0;
    typingRef.current = setInterval(() => {
      if (index <= fullText.length) {
        setDisplayText(fullText.substring(0, index));
        index++;
      } else {
        clearInterval(typingRef.current);
      }
    }, 120);
    return () => clearInterval(typingRef.current);
  }, [fullText]);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor(prev => !prev);
    }, 500);
    return () => clearInterval(cursorInterval);
  }, []);

  return (
    <section className="hero" id="hero">
      <div className="hero-overlay"></div>
      <div className="hero-grid-bg"></div>

      <div className="hero-content container">
        <motion.div
          className="hero-text-wrapper"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          <div className="hero-greeting">
            <span className="hero-terminal-line">
              {lang.HERO_TERMINAL || '>_ root@ispclub:~/# ./ispclub --information'}
            </span>
          </div>

          <h1 className="hero-title">
            <span className="hero-title-text">{displayText}</span>
            <span className={`hero-cursor ${showCursor ? 'visible' : ''}`}>_</span>
          </h1>

          <motion.p
            className="hero-subtitle"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.2, duration: 0.6 }}
          >
            {lang.HERO_SUBTITLE || 'EXPLOIT SOMETHING BIG'}
          </motion.p>

          <motion.p
            className="hero-description"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 1.6, duration: 0.6 }}
          >
            {lang.HERO_DESCRIPTION || 'Information Security Club at PTIT'}
          </motion.p>

          <motion.div
            className="hero-actions"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 2, duration: 0.6 }}
          >
            <Link to="/about" className="btn btn-primary">
              <span>{lang.HERO_CTA_PRIMARY || 'Learn More'}</span>
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
            <Link to="/recruitment" className="btn btn-outline">
              <span>{lang.HERO_CTA_SECONDARY || 'Join Now'}</span>
            </Link>
          </motion.div>
        </motion.div>

        <motion.div
          className="hero-visual"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <div className="hero-code-block">
            <div className="code-header">
              <span className="code-dot red"></span>
              <span className="code-dot yellow"></span>
              <span className="code-dot green"></span>
              <span className="code-filename">{lang.HERO_CODE_FILENAME || 'isp_club.py'}</span>
            </div>
            <div className="code-body">
              <pre>
                <code>
{`class ISPClub:
    def __init__(self):
        self.name = "ISP Club"
        self.school = "PTIT"
        self.focus = [
            "Web Security",
            "Reverse Engineering",
            "Cryptography",
            "Forensics",
            "Pwn/Binary"
        ]
        self.status = "Active"

    def welcome(self):
        return "Join us!"`}
                </code>
              </pre>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;
